import React from 'react';
import { useFormContext } from './Provider';
import { useModalContext } from '../Modal/Provider';

const Inner = ({children, onSubmit, layout}) => {

    const {formData, isValid, setIsValidating, setIsSubmitting, closeModalOnSubmit, goBackOnSubmit, afterSubmit} = useFormContext();
    const modalContext = useModalContext();

    const handleSubmit = async (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (isValid !== true) {
            setIsValidating(true);
            return;
        }

        setIsSubmitting(true);
        try {
            await onSubmit(formData);

            afterSubmit && afterSubmit(formData);
            closeModalOnSubmit && modalContext?.closeModal();
            goBackOnSubmit && window.history.back();
        } catch (e) {
            setIsSubmitting(false);
            console.error(e);
        }
        setIsSubmitting(false);
    }

    const layoutClasses = {
        'horizontal': 'flex flex-row justify-between',
        'vertical': 'flex flex-col gap-y-3'
    };

    return <form onSubmit={handleSubmit}>
        <div className={layoutClasses[ layout ?? 'vertical']}>
            {children}
        </div>
    </form>
};

export default Inner;
